<template>
  <span v-html="content" />
</template>

<script>
export default {
  name: 'I18n',
  props: {
    path: { type: String, default: undefined }
  },
  data () {
    return {
      content: null
    }
  },
  methods: {
    loadValue () {
      let value = null
      if (this.path) {
        const arr = this.path.split('.')
        const i18n = this.$store.state.i18n
        for (const prop of arr) {
          if (prop) value = value ? value[prop] : i18n[prop]
        }
      }
      this.content = value
    }
  },
  watch: {
    '$store.state.language' (val) {
      this.loadValue()
    }
  },
  mounted () {
    this.loadValue()
  }
}
</script>
